import { Skeleton } from '@/ui/design-system/components/ui/skeleton';

function SearchResultsSkeleton() {
    return (
        <div className="flex gap-1 p-1">
            {[8, 5, 3].map((count, gi) => (
                <div
                    key={gi}
                    className={`flex-1 space-y-1${gi === 1 ? ' hidden md:block' : ''}${gi === 2 ? ' hidden lg:block' : ''}`}
                >
                    <div className="px-2 py-1.5">
                        <Skeleton className="h-3 w-16 bg-neutral-200" />
                    </div>
                    {Array.from({ length: count }, (_, i) => (
                        <div
                            key={i}
                            className="flex min-h-[44px] items-center gap-2 px-2"
                        >
                            <Skeleton
                                className="h-4 bg-neutral-200"
                                style={{
                                    width: `${45 + ((gi * 7 + i * 13) % 40)}%`,
                                }}
                            />
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}

export default SearchResultsSkeleton;
